import { useTranslation } from "react-i18next";

const reasons = [
  { icon: "ri-building-2-line", titleKey: "reason1_title", descKey: "reason1_desc" },
  { icon: "ri-line-chart-line", titleKey: "reason2_title", descKey: "reason2_desc" },
  { icon: "ri-flashlight-line", titleKey: "reason3_title", descKey: "reason3_desc" },
  { icon: "ri-compass-3-line", titleKey: "reason4_title", descKey: "reason4_desc" },
];

export default function WhyInvestSection() {
  const { t } = useTranslation();

  return (
    <section id="invest" className="relative py-16 md:py-32 bg-[#070b14]">
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "radial-gradient(ellipse at 50% 0%, rgba(255,180,0,0.4) 0%, transparent 60%)" }} />
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-16 items-center">
          <div className="relative">
            <div className="relative rounded-lg overflow-hidden h-[280px] sm:h-[380px] md:h-[500px]">
              <img
                src="https://public.readdy.ai/ai/img_res/5028f5d3c12010cbaa5bda5d36678226.jpg"
                alt="Astronaut on moon"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-[#070b14]/60 to-transparent" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#070b14] via-transparent to-transparent" />
            </div>
            <div className="absolute bottom-4 md:bottom-8 left-4 md:left-8 right-4 md:right-8 p-3 md:p-5 bg-black/70 backdrop-blur-md border border-amber-400/20 rounded-lg">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-amber-400/10 border border-amber-400/30 flex-shrink-0">
                  <i className="ri-global-line text-amber-400 text-sm md:text-base" />
                </div>
                <div>
                  <div className="text-white font-bold text-xs md:text-sm" style={{ fontFamily: "'Orbitron', sans-serif" }}>{t("invest_global")}</div>
                  <div className="text-white/40 text-[10px] md:text-xs mt-0.5">{t("invest_global_sub")}</div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="inline-flex items-center gap-2 mb-4 md:mb-6">
              <div className="w-6 md:w-8 h-px bg-amber-400/60" />
              <span className="text-amber-400 text-[10px] md:text-xs tracking-[0.3em] uppercase" style={{ fontFamily: "'Orbitron', sans-serif" }}>{t("invest_badge")}</span>
            </div>
            <h2 className="text-2xl md:text-5xl font-black text-white mb-3 md:mb-4 leading-tight" style={{ fontFamily: "'Orbitron', sans-serif" }}>
              {t("invest_title_1")}
              <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-300 to-orange-400">ARTEMIDA</span>
            </h2>
            <p className="text-white/50 text-xs md:text-sm mb-6 md:mb-10 leading-relaxed">{t("invest_subtitle")}</p>
            <div className="space-y-4 md:space-y-6">
              {reasons.map((r, i) => (
                <div key={i} className="flex gap-3 md:gap-4 group">
                  <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-amber-400/10 border border-amber-400/20 flex-shrink-0 group-hover:bg-amber-400/20 transition-colors">
                    <i className={`${r.icon} text-amber-400 text-sm md:text-base`} />
                  </div>
                  <div>
                    <h3 className="text-white font-semibold text-xs md:text-sm mb-1" style={{ fontFamily: "'Orbitron', sans-serif" }}>{t(r.titleKey)}</h3>
                    <p className="text-white/40 text-xs md:text-sm leading-relaxed">{t(r.descKey)}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
